import { IFee, IServerOrder } from '@rbi-ctg/menu';
import { TranslationKey } from 'state/intl/types';

import { FEES } from './constants';
import { IGetStandardizedName } from './types';

export const getStandardizedName = ({ name }: IGetStandardizedName): string => FEES[name] ?? name;

export const getFeesByGroup = (fees: IFee[]) =>
  (fees || []).reduce((acc: Record<TranslationKey, number>, val: IFee) => {
    // The fees names are not typed as TranslationKey in the backend, so we need to cast them here
    const name = val.name;

    if (!acc[name]) {
      acc[name] = 0;
    }

    acc[name] += val.totalCents;

    return acc;
  }, {} as Record<TranslationKey, number>);

enum DONATIONS {
  ROUND_UP = '',
}
// TODO this donation code will likely evolve as we implement. this was stolen from rGuest for the mparticle -> amplitude migration
export const getRoundUpDonations = (serverOrder: IServerOrder | null) =>
  serverOrder?.cart?.donations?.find(({ name }) => name === DONATIONS.ROUND_UP);
